/* eslint-disable react-native/no-inline-styles */
import React, { memo, useCallback } from 'react'

import images from '@batical/common/src/images/index'
import i18n from '@batical/i18n'
import { CalculCodeStateKeys } from '@batical/types/src'
import { styled } from '@mui/material'

import { useIsFocusedCalculLink, ViewLine, CalculText, sectionColors } from '..'

export type CalculLinkProps = {
  sectionCode: string
  calcul: CalculCodeStateKeys
  onBack: () => void
  calculCode: CalculCodeStateKeys
  /**
   * if true, the line is the first of a group
   *
   * @type {boolean}
   */
  first?: boolean
  /**
   * if true, the line is the last of a group
   *
   * @type {boolean}
   */
  last?: boolean
}
const CalculLink = ({ calcul, first, last, sectionCode, onBack, calculCode }: CalculLinkProps) => {
  const nav = useIsFocusedCalculLink(calculCode, calcul, onBack)

  const onPress = useCallback(() => {
    nav()
  }, [nav])

  return (
    <ViewLine onClick={onPress} first={first} last={last} style={{ justifyContent: 'flex-start' }}>
      <ProductImgStyle src={images[sectionCode]} style={{ backgroundColor: sectionColors[sectionCode], marginRight: 16 }} />
      <CalculText>{i18n.t(`${calculCode}_${calcul}`)}</CalculText>
    </ViewLine>
  )
}

export default memo(CalculLink)

const ProductImgStyle = styled('img')({
  width: 36,
  height: 36,
  borderRadius: 6
})
